$(document).ready(function(){
  if ($.fn.slick) $('.testimonials__slider1').not('.slick-initialized').slick({
    infinite: true,
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: '29%',
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          centerPadding: '20%',
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: '10%',
        }
      }
    ]
  });
  
  if ($.fn.slick) $('.piq-instafeed__slider').not('.slick-initialized').slick({
    infinite: true,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    centerMode: true,
    centerPadding: '10%',
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  var maxHeight = 0;
  $('.testimonials__slider1 .testimonial__item').each(function(){
     if ($(this).find('.testimonial__item__content').innerHeight() > maxHeight) {
         maxHeight = $(this).find('.testimonial__item__content').innerHeight();
     }
  });
  $('.testimonials__slider1 .testimonial__item__content').css("min-height", maxHeight);
});

$(window).resize(function(){
  var maxHeight = 0;
  $('.testimonials__slider1 .testimonial__item').each(function(){
     if ($(this).find('.testimonial__item__content').innerHeight() > maxHeight) {
         maxHeight = $(this).find('.testimonial__item__content').innerHeight();
     }
  });
  $('.testimonials__slider1 .testimonial__item__content').css("min-height", maxHeight);
});